export default __webpack_public_path__ + "poi-800-7d6b5c8a231aa60bb8206e0aea159d87.png";